module.exports = {"ADM_EDIT_USER_PERSONAL_INFO":"Datos personales","ADM_EDIT_USER_LOCATION_AND_PHONE":"Ubicación y celular","ADM_EDIT_USER_SAVE":"Guardar"}